import {CSSProperties} from "react";
import {useApp} from "../app.context";

// Either flat options or grouped (with section headers via <optgroup>).
// Mutually exclusive — pass one, not both.
export interface SelectableGroup<T> {
    label: string;
    options: T[];
}

export interface SelectableProps<T> {
    value: T;
    options?: T[];
    groups?: SelectableGroup<T>[];
    onChange(value: T): void;
    style?: CSSProperties;
}

function Selectable<T extends string | number>(props: SelectableProps<T>) {
    const {getLocalizationValue} = useApp();

    return (
        <select style={{...{width: '200px'}, ...props.style}} defaultValue={props.value} onChange={(v) => {
            props.onChange(v.target.value as T);
        }}>
            {props.groups
                ? props.groups.map((group, gi) => (
                    <optgroup key={gi} label={group.label}>
                        {group.options.map((id, index) => (
                            <option key={index} value={id}>{getLocalizationValue(id.toString())}</option>
                        ))}
                    </optgroup>
                ))
                : (props.options ?? []).map((id, index) => (
                    <option key={index} value={id}>{getLocalizationValue(id.toString())}</option>
                ))}
        </select>
    )
}

export default Selectable;